import script from "./StatusFieldsHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusFieldsHandler.vue?vue&type=script&setup=true&lang=js"

import "./StatusFieldsHandler.vue?vue&type=style&index=0&id=9fa4bd1c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fa4bd1c"]])

export default __exports__